<template>
  <div class="footer py-4 d-flex flex-lg-column" id="kt_footer">
    <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
      <div class="text-gray-900 order-2 order-md-1"></div>
      <div class="text-gray-900 order-2 order-md-1">
        <span class="text-muted fw-semibold me-1">{{ new Date().getFullYear() }} &copy;</span>
        <a href="https://energocharge.uz/" target="_blank" class="text-gray-800 text-hover-primary">Energocharge</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VFooter'
}
</script>

<style scoped>

</style>